export const removeCPFMask = (value) => {
  return value.replace(/\D+/g, "").trim();
};
